export default __webpack_public_path__ + "static/media/logo.ba12a751.png";